export default "__VITE_ASSET__CeTr$PHW__"